import {handleExpiredToken} from '../../helpers/removeCurrUser'

export const getRequest = async ({url}) => {
    try {
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const data = await response.json();

        // check for error response
        if (!response.ok) {

            if (response.status === 401) {
                handleExpiredToken()
                return
            }
            // get error message from body or default to response status
            return {
                error: data.error,
                status: response.status,
                prettyError: data.prettyError
            }
        }

        return data

    } catch (err) {
        console.error(err)
    }
}